import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from 'src/app/shared/material.module';
import { DxTreeListComponent } from 'devextreme-angular';
import { ManagementApiService, UserUtilityService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import { ApprovalDeliveryGroupModel, ApprovalDeliveryGroupValue, deliveryGroupUser } from '../../models/common/setting-area.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DbSelectLookUpModel } from '../../models/idms/db-select-look-up.model';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-add-delivery-group-modal',
    templateUrl: './add-delivery-group-modal.component.html',
    styleUrl: './add-delivery-group-modal.component.scss',
})
export class AddDeliveryGroupModalComponent {
    @Input() DeliveryGroupList: any[];
    @Output() deliveryGroupUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();
    @ViewChild('treeList', { static: false }) treeList!: DxTreeListComponent;
    addDeleiveryGroupFormGroup: UntypedFormGroup;
    finaldataForSave: ApprovalDeliveryGroupModel[] = [];
    finalDataForDelete: ApprovalDeliveryGroupModel[] = [];
    iscreateRule: boolean;
    iseditRule: boolean;
    isDeleteRolevisible: boolean;
    disableEdit = true;
    disableCancel = true;
    isValidData: boolean = false;
    userData: deliveryGroupUser[];
    userDataList: any[];
    editedCells: { [key: number]: Set<string> } = {};
    constructor(
        private ngbActiveModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
        private ngxUiLoaderService: NgxUiLoaderService,
        private userUtilityService: UserUtilityService,
        private customValidator: CustomValidatorService,
        private customToastService: CustomToastService,
        private user_utility: UserUtilityService,
        private mgmtApi: ManagementApiService,
        private cd: ChangeDetectorRef,
        private globalEmitterService: GlobalEmittersService,
        private transLocoService: TranslocoService
    ) {}

    createFormControls() {
        this.addDeleiveryGroupFormGroup = this.formBuilder.group({
            name: [, [Validators.required]],
        });
    }

    async ngOnInit() {
        this.iseditRule = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-rules', userActions.Edit);
        this.isDeleteRolevisible = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-rules', userActions.Delete);
        this.iscreateRule = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-rules', userActions.Create);
        this.createFormControls();
        this.LoaduserDeliveryGroups();
        this.globalEmitterService.deliveryGroupUpdateEvent.subscribe((resp) => {
            if (resp) {
                this.DeliveryGroupList = resp;
                this.cd.detectChanges();
            }
        });
    }

    closeClick() {
        this.ngbActiveModal.close();
    }

    addButtonClick() {
        if (this.addDeleiveryGroupFormGroup.valid) {
            if (this.treeList) {
                this.treeList.instance.saveEditData();
            }
        }
        console.log('form value', this.addDeleiveryGroupFormGroup.value);
    }

    initNewRow(e: any) {
        e.data.parentId = e.data.parentId ? e.data.parentId : 0;
        this.disableEdit = false;
        this.disableCancel = false;
    }

    undoAllChanges() {
        if (this.treeList) {
            this.treeList.instance.cancelEditData();
        }
        this.disableEdit = true;
        this.disableCancel = true;
    }

    handlePropertyChange(e: any) {
        this.disableEdit = false;
        this.disableCancel = false;
    }

    saveAllChanges() {
        if (this.treeList) {
            this.treeList.instance.saveEditData();
        }
    }

    handleRowRemoving(e: any) {}

    onRowRemoved(e: any) {}

    onRowInserted(e: any) {
        if (e.data) {
            const data = e.data;
        }
    }

    onRowUpdated(e: any) {
        if (e.data) {
            const data = e.data;
        }
    }

    handledeleteRow(e: any) {
        if (e.data) {
            const data = e.data;
        }
    }

    handleundeleteRow(e: any) {
        if (e.data) {
            const data = e.data;
        }
    }

    customizeToolbar(e: any) {
        e.toolbarOptions.items = [];
    }

    handleCellPrepared(e: any) {
        if (e.cellElement) {
            e.cellElement.classList.remove('dx-cell-modified');
        }
        if (e.rowType === 'data' && e.column.dataField) {
            const rowKey = e.key;
            const dataField = e.column.dataField;
            // Check if this cell has been edited
            if (this.editedCells[rowKey] && this.editedCells[rowKey].has(dataField)) {
                e.cellElement.style.backgroundColor = 'green'; // Apply custom background color
                e.cellElement.style.color = 'red'; // Apply custom background color
            }
        }
    }

    handleRowPrepared(e: any) {
        if (e.rowType === 'data') {
            const hasChildren = this.hasChildren(e.key);
            if (hasChildren) {
                const hrElement = document.createElement('hr');
                e.rowElement.appendChild(hrElement);
            }
        }
    }

    hasChildren(rowKey: any): boolean {
        // Check if the current row has children based on the rowKey
        //  const childRows = this.data.filter(item => item.parentId === rowKey);
        //   return childRows.length > 0;
        return true;
    }

    trackEditedCell(e: any) {
        const rowKey = e.key; // The row key of the edited cell
        const dataField = e.column.dataField; // The data field (column) of the edited cell

        // Track edited cells using a map
        if (!this.editedCells[rowKey]) {
            this.editedCells[rowKey] = new Set<string>();
        }
        this.editedCells[rowKey].add(dataField);
    }

    handleSaving(e: any) {
        this.finaldataForSave = [];
        this.finalDataForDelete = [];
        // let dataForDelete = [];
        const changes = e.changes;
        const addedRecords = changes.filter((change) => change.type === 'insert');
        const updatedRecords = changes.filter((change) => change.type === 'update');
        const removedRecords = changes.filter((change) => change.type === 'remove');

        let dataforSave: ApprovalDeliveryGroupModel[] = [];
        if (addedRecords && addedRecords.length > 0) {
            dataforSave.push(addedRecords);
        }
        if (updatedRecords && updatedRecords.length > 0) {
            dataforSave.push(updatedRecords);
        }
        if ((addedRecords && addedRecords.length > 0) || (updatedRecords && updatedRecords.length > 0)) {
            this.finaldataForSave = this.converttovaluelist(dataforSave);
        }
        if (removedRecords && removedRecords.length > 0) {
            // ❌ Stop DevExtreme from auto-committing
            e.cancel = true;

            this.finalDataForDelete = this.delete(removedRecords);
        }
        if (this.finalDataForDelete.length > 0 && this.finaldataForSave.length > 0) {
            const selectedKeys = removedRecords.map((item) => item.key);
            this.saveLookUpFieldChanges(false, this.finaldataForSave, selectedKeys, this.finalDataForDelete);
        } else if (this.finaldataForSave.length > 0) {
            this.saveLookUpFieldChanges(false, this.finaldataForSave);
        } else if (this.finalDataForDelete.length > 0) {
            const selectedKeys = removedRecords.map((item) => item.key);
            this.saveLookUpFieldChanges(true, this.finalDataForDelete, selectedKeys);
        }
    }

    getChild(parentId: string) {
        return this.DeliveryGroupList.filter((x) => x.id == parentId);
    }

    converttovaluelist(dataforSave: any) {
        let finalSave: ApprovalDeliveryGroupModel[] = [];
        if (dataforSave && dataforSave.length > 0) {
            dataforSave[0].forEach((x) => {
                if (x) {
                    if (x.name) {
                        this.isValidData = this.customValidator.validateSqlInjectionforDevExpress(x.name);
                        if (!this.isValidData) {
                            this.customToastService.errorToast('Alias contains invalid characters.');
                        }
                    }

                    if (x.data.parentId) {
                        let child: any = {};
                        let userid = this.userData.find((y) => y.profileContact.email == x.data.name).userId;
                        child['userId'] = userid;
                        const parent = this.getChild(x.data.parentId);

                        if (finalSave && finalSave.length > 0) {
                            const p = finalSave.filter((x) => x.name == parent[0].name);
                            if (p && p.length > 0) {
                                p[0].userDeliveryGroups.push(child);
                            } else {
                                if (parent && parent.length > 0) {
                                    // parent[0].userDeliveryGroups = [child];
                                    let data: any = {};
                                    data.userDeliveryGroups = [child];
                                    data.deliveryGroupId = parent[0].id;
                                    data.name = parent[0].name;
                                    finalSave.push(data);
                                }
                                // finalSave.push(parent[0]);
                            }
                        } else {
                            if (parent && parent.length > 0) {
                                let data: any = {};
                                data.userDeliveryGroups = [child];
                                data.deliveryGroupId = parent[0].id;
                                data.name = parent[0].name;
                                finalSave.push(data);
                            }
                        }
                    } else {
                        let a: ApprovalDeliveryGroupModel = new ApprovalDeliveryGroupModel();
                        a.name = x.data.name;
                        if (x?.type == 'update' && x?.key) {
                            a.deliveryGroupId = x.key;
                        }
                        a.userDeliveryGroups = [];
                        finalSave.push(a);
                    }
                }
            });
        }
        //this.saveLookUpFieldChanges(false, finalSave);
        this.disableEdit = false;
        this.disableCancel = false;
        return finalSave;
    }

    // * api call to save the lookUp field changes
    saveLookUpFieldChanges(isDelete: boolean, payload?: ApprovalDeliveryGroupModel[], keys?: any, deletePayload?: ApprovalDeliveryGroupModel[]): void {
        const instanceId = localStorage.getItem('currentInstanceId');
        if (instanceId) {
            this.ngxUiLoaderService.start();
            if (payload.find((m) => m.deliveryGroupId) || isDelete) {
                this.mgmtApi.updateDeliveryGroup(payload).subscribe(
                    (res) => {
                        this.ngxUiLoaderService.stop();
                        if (res.success) {
                            if (!isDelete) {
                                this.customToastService.successToast(
                                    this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.DELIVERY_GROUP_UPDATED_SUCCESSFULLY')
                                );

                                if (deletePayload?.length > 0) {
                                    this.saveLookUpFieldChanges(true, deletePayload, keys);
                                }
                            } else {
                                this.customToastService.successToast(
                                    this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.DELIVERY_GROUP_DELETED_SUCCESSFULLY')
                                );
                                // const dataSource = this.treeList.instance.getDataSource();
                                // const items = dataSource.items(); // flattened rows
                                // keys.forEach((key) => {
                                //     const index = items.findIndex((item) => item.id === key);
                                //     this.treeList.instance.deleteRow(index);
                                // });
                                const dataSource = this.treeList.instance.getDataSource();

                                keys.forEach((key) => {
                                    dataSource.store().remove(key);
                                });

                                dataSource.reload();
                                this.undoAllChanges();
                                // if (deletePayload?.length > 0) {
                                //     this.saveLookUpFieldChanges(true, deletePayload, keys);
                                // }
                            }
                            this.deliveryGroupUpdated.emit(true); // ✅ send updated data
                            this.disableEdit = true;
                        } else {
                            this.undoAllChanges();
                            this.userUtilityService.errorModelPopup(res.message);
                        }
                    },
                    (err) => {
                        this.ngxUiLoaderService.stop();
                        this.userUtilityService.errorModelPopup(err);
                    }
                );
            } else {
                this.mgmtApi.saveDeliveryGroup(payload).subscribe(
                    (res) => {
                        this.ngxUiLoaderService.stop();
                        if (res.success) {
                            if (deletePayload?.length > 0) {
                                this.saveLookUpFieldChanges(true, deletePayload, keys);
                            } else {
                                this.customToastService.successToast(
                                    this.transLocoService.translate('SETTING_PAGE.IDMS_SETTINGS.DELIVERY_GROUP_UPDATED_SUCCESSFULLY')
                                );
                            }
                            this.undoAllChanges();
                            this.deliveryGroupUpdated.emit(true); // ✅ send updated data
                            this.disableEdit = true;
                        } else if (res.message) {
                            this.userUtilityService.errorModelPopup(res.message);
                        } else {
                            this.userUtilityService.errorModelPopup(
                                this.transLocoService.translate(
                                    'SETTING_PAGE.IDMS_SETTINGS.UNABLE_TO_UPDATE_DELIVERY_GROUPS_PLEASE_TRY_AGAIN_LATER_OR_CONTACT_ADMINISTRATOR'
                                )
                            );
                        }
                    },
                    (err) => {
                        this.ngxUiLoaderService.stop();
                        this.userUtilityService.errorModelPopup(err);
                    }
                );
            }
        }
    }

    addNewRow() {
        if (this.treeList) {
            this.treeList.instance.addRow();
        }
    }

    delete(deleteData: any[]) {
        let dellist: any[] = [];
        const selectedKeys = deleteData.map((item) => item.key);
        const filteredData = this.DeliveryGroupList.filter((dg) => selectedKeys.includes(dg.id));
        let parentData = filteredData.filter((x) => x.parentId == 0);
        if (parentData && parentData.length > 0) {
            parentData.forEach((pd) => {
                let data: any = {};
                data.active = false;
                data.deliveryGroupId = pd.id;
                dellist.push(data);
            });
        }

        let childData = filteredData.filter((x) => x.parentId != 0);
        if (childData && childData.length > 0) {
            childData.forEach((db) => {
                let c: any = {};
                c.userDeliveryGroupId = db.id;
                c.active = false;
                const delListData = dellist.find((m) => m.deliveryGroupId == db.parentId && m.active == false);
                if (!delListData) {
                    const _delListData = dellist.find((m) => m.deliveryGroupId == db.parentId && m.active != false);
                    if (!_delListData) {
                        let data: any = {};
                        data.deliveryGroupId = db.parentId;
                        data.name = this.DeliveryGroupList.find((x) => x.id == db.parentId).name;
                        data.userDeliveryGroups = [c];
                        dellist.push(data);
                    } else {
                        _delListData.userDeliveryGroups.push(c);
                    }
                }
            });
        }
        return dellist;
        //this.saveLookUpFieldChanges(true, dellist, selectedKeys);
    }

    allowAdding = (e) => {
        return e.row.data.parentId == 0;
    };

    allowAdding2 = (e) => {
        return e.row.data.parentId == 0;
    };

    allowDelete = (e) => {
        return e.row.data.parentId == 0 ? false : true;
    };

    onEditorPreparingDBSelect(e: any) {
        if (e.parentType === 'dataRow' && e.dataField === 'name') {
            const row = e.row?.data;

            if (row?.parentId && row.parentId !== 0 && row.parentId !== '0') {
                // It’s a child row → use dxSelectBox with search
                e.editorName = 'dxSelectBox';
                e.editorOptions = {
                    dataSource: this.userDataList,
                    displayExpr: 'name',
                    valueExpr: 'name',
                    searchEnabled: true,
                    minSearchLength: 1,
                    showClearButton: true,
                    value: e.value,
                    onValueChanged: (args: any) => {
                        e.setValue(args.value);
                        const result = this.customValidator.validateSqlInjectionforDevExpress(args.value);
                        if (!result) {
                            //  event.event.preventDefault();
                            this.customToastService.errorToast('Input contains invalid characters.');
                        }
                    },
                };
            } else {
                // It’s a parent row → normal textbox (default)
                e.editorName = 'dxTextBox';
                e.editorOptions = {
                    value: e.value,
                    onValueChanged: (args: any) => {
                        e.setValue(args.value);
                        e.editorOptions.onKeyDown = (event) => {
                            const input = event.component?.element().querySelector('input');
                            const result = this.customValidator.validateSqlInjectionforDevExpress(input?.value);
                            if (!result) {
                                event.event.preventDefault();
                                this.customToastService.errorToast('Input contains invalid characters.');
                            }
                        };

                        e.editorOptions.onInput = (event) => {
                            const input = event.component?.element().querySelector('input');
                            const result = this.customValidator.validateSqlInjectionforDevExpress(input?.value);

                            if (!result) {
                                event.event.preventDefault();
                                this.customToastService.errorToast('Input contains invalid characters.');
                            }
                        };
                        // }
                    },
                };
            }
        }
    }

    DataVisible() {
        return this.DeliveryGroupList.length > 0;
    }

    dbLookUpItemsNewData() {
        return this.DeliveryGroupList;
    }

    mapDbselect(dblookup: ApprovalDeliveryGroupModel[], parentId: string) {
        const result = [];
        dblookup.forEach((array) => {
            const parentItem = {
                id:
                    array.deliveryGroupId == null || array.deliveryGroupId == '' || array.deliveryGroupId == undefined
                        ? array.userDeliveryGroupId
                        : array.deliveryGroupId,
                name: array.name,
                parentId: '',
            };
            result.push(parentItem);

            if (array?.userDeliveryGroups && array?.userDeliveryGroups?.length > 0) {
                let childItems = array.userDeliveryGroups.map((child) => ({
                    id: child.userDeliveryGroupId,
                    name: child.user.userId,
                    parentId: array.deliveryGroupId,
                }));
                result.push(...childItems);
            }
        });

        this.DeliveryGroupList = result;
        this.cd.detectChanges();
    }

    async LoaduserDeliveryGroups() {
        let data = await this.mgmtApi.getusersfordeliverygroupallocation().toPromise();
        if (data.success) {
            this.userData = data.response;
            this.mapUserDeliverygroup(data.response);
        } else if (data.message) {
            this.userUtilityService.errorModelPopup(data.message);
        }
    }

    mapUserDeliverygroup(dblookup: deliveryGroupUser[]) {
        const result = [];
        dblookup.forEach((array) => {
            const parentItem = {
                id: array.userId,
                name: array.profileContact.email,
            };
            result.push(parentItem);
        });

        this.userDataList = result;
    }
}
